import { Dispatch, FC, SetStateAction, useCallback } from 'react'
import { List, ListItem, ListItemIcon, ListItemText } from '@zoom/react-ui'
import { IconCheckmark } from '@zoom/icons-react'
import {
  useSubscribeMutation,
  useUnsubscribeMutation,
} from '../app/appApiQueries'

type NotificationPreferencesProps = {
  setOpen: Dispatch<SetStateAction<boolean>>
  isChatEnabled?: boolean
}
const NotificationPreferences: FC<NotificationPreferencesProps> = ({
  setOpen,
  isChatEnabled,
}) => {
  const [subscribe] = useSubscribeMutation()
  const [unsubscribe] = useUnsubscribeMutation()

  const handleNotificationPreferences = useCallback(
    (newPreference: boolean) => {
      if (isChatEnabled !== newPreference) {
        if (newPreference) {
          subscribe('Google')
        } else {
          unsubscribe('Google')
        }
      }
      setOpen(false)
    },
    [isChatEnabled, setOpen, subscribe, unsubscribe]
  )

  return (
    <List divider={false}>
      <div className='px-2 pb-[6px] pt-[20px] font-bold'>
        Notification preferences:
      </div>
      <ListItem className='cursor-pointer'>
        <ListItemIcon>
          {isChatEnabled && <IconCheckmark color='#0E72ED' />}
        </ListItemIcon>
        <ListItemText
          onClick={() => handleNotificationPreferences(true)}
          primary='Notifications in Team Chat'
          secondary='Get notified about new comments, access requests, and files shared.'
        />
      </ListItem>
      <ListItem className='cursor-pointer'>
        <ListItemIcon>
          {!isChatEnabled && <IconCheckmark color='#0E72ED' />}
        </ListItemIcon>
        <ListItemText
          onClick={() => handleNotificationPreferences(false)}
          primary='Off'
          secondary='Turn off chat notifications.'
        />
      </ListItem>
    </List>
  )
}

export default NotificationPreferences
